var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.309 34.6666H23.1215C31.2986 34.6666 34.5694 31.3958 34.5694 23.2187V13.4062C34.5694 5.22915 31.2986 1.95831 23.1215 1.95831H13.309C5.13192 1.95831 1.86108 5.22915 1.86108 13.4062V23.2187C1.86108 31.3958 5.13192 34.6666 13.309 34.6666Z",
    stroke: "#555454",
    strokeWidth: 2.18056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1214 23.8403H15.0752C12.295 23.8403 10.0381 21.5834 10.0381 18.8032C10.0381 16.023 12.295 13.7661 15.0752 13.7661H26.1469",
    stroke: "#555454",
    strokeWidth: 2.18056,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8247 16.3007L26.3923 13.7168L23.8247 11.1492",
    stroke: "#555454",
    strokeWidth: 2.18056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.f7ea44d8a6ebebae92c057b15a59c051.svg";
export { ForwardRef as ReactComponent };